import React, { useState, useEffect } from 'react';
import './WorklogReport.css';
import Navbar from '../../Navbar/Navbar';
import DatePicker from 'react-datepicker';
import { useDispatch, useSelector } from "react-redux";
import { startOfMonth, endOfMonth } from "date-fns";
import { empList } from '../../../Redux/DailyUpdateApproval/Action';
import Select from "react-select";
import { fetchWorkLogData } from '../../../Redux/Task/Action';
import NewDataTable from '../../DataTable/NewDataTable';


const WorklogReport = () => {
    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const role = localStorage.getItem("role");
    const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
    const [toDate, setToDate] = useState(endOfMonth(new Date()));
    const { emplists } = useSelector((store) => store.dailyUpdateApprover);
    const [selectedEmployee, setSelectedEmployee] = useState(null);

    const { fetchWorklogData } = useSelector((store) => store.task);


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const handleEmpChange = (selectedOption) => {
        setSelectedEmployee(selectedOption);
    };

    useEffect(() => {
        dispatch(empList(token));
    }, [])

    let options = [
        { value: 'All', label: 'All' },
        ...emplists.map((emp) => ({
            value: emp.loginId,
            label: `${emp.firstName} ${emp.lastName}`,
        })),
    ];

    if (role === "ROLE_EMP") {
        options = options.filter((opt) => opt.value === loginId);
    }

    useEffect(() => {
        if (options.length > 0 && selectedEmployee === null) {
            setSelectedEmployee(options[0]);
        }
    }, [options, selectedEmployee]);


    useEffect(() => {
        if (selectedEmployee && fromDate && toDate) {
            dispatch(fetchWorkLogData(selectedEmployee.value, token, formatDate(fromDate), formatDate(toDate)));
        }
    }, [dispatch, selectedEmployee, fromDate, toDate,])


    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },


        ...(role === "ROLE_ADMIN"
            ? [
                {
                    name: "Employee Name",
                    selector: (row) => row.empName,
                    sortable: true,
                    align: "center",
                },
            ]
            : []),
        {
            name: "Task No",
            selector: (row) => row.taskNo,
            sortable: true,
            align: "center",
        },

        {
            name: "Project Code",
            selector: (row) => row.projectCode,
            sortable: true,
            align: "center",
        },
        {
            name: "Task Title",
            selector: (row) => row.taskTitle,
            sortable: true,
            align: "left",
        },
        {
            name: "Date",
            selector: (row) => row.date,
            sortable: true,
            align: "center",
        },
        {
            name: "Hours",
            selector: (row) => row.totalHour,
            sortable: true,
            align: "center",
        },
        {
            name: "Remark",
            selector: (row) => row.remarks,
            sortable: true,
            align: "left",
        },
    ];


    return (
        <div>
            <Navbar></Navbar>

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="row mb-3 justify-content-end align-items-center flex-wrap">

                        {/* Employee Select */}
                        <div className="col-auto d-flex align-items-center flex-nowrap mb-2 mb-sm-0">
                            <b>
                                <label className="me-1 mb-0 custom-label">Employee:</label>
                            </b>
                            <div style={{ width: "300px" }}>
                                <Select
                                    options={options}
                                    value={selectedEmployee}
                                    onChange={handleEmpChange}
                                    placeholder="Select Employee"
                                    isClearable
                                />
                            </div>
                        </div>

                        {/* From & To Dates in one row */}
                        <div className="col-auto d-flex align-items-center flex-nowrap mb-2 mb-sm-0">
                            <b>
                                <label className="me-1 mb-0 custom-label cstm-label">From Date:</label>
                            </b>
                            <DatePicker
                                selected={fromDate}
                                onChange={(newValue) => setFromDate(newValue)}
                                className="form-control me-3"
                                dateFormat="dd-MM-yyyy"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                onKeyDown={(event) => event.preventDefault()}
                            />

                            <b>
                                <label className="me-1 ms-2 mb-0 custom-label cstm-label">To Date:</label>
                            </b>
                            <DatePicker
                                selected={toDate}
                                onChange={(newValue) => setToDate(newValue)}
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                onKeyDown={(event) => event.preventDefault()}
                                minDate={fromDate}
                            />
                        </div>

                    </div>

                    <div>
                        <NewDataTable
                            columns={columns}
                            data={fetchWorklogData.taskWorkLogList || []}
                            tableName="WORKLOG LIST"
                        />
                    </div>
                </div>
            </div>


        </div>

    );
};

export default WorklogReport;